import { render, staticRenderFns } from "./RanchTrialShowResultsEntry.vue?vue&type=template&id=4a9784b2"
import script from "./RanchTrialShowResultsEntry.vue?vue&type=script&lang=ts"
export * from "./RanchTrialShowResultsEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports